export default __webpack_public_path__ + "static/media/more-features.b1b28fec.png";